import { defineNuxtPlugin } from "#app"
import type {
  ObjectDirective,
  DirectiveBinding
} from '@vue/runtime-core'

// Code below is based on the original plugin
// https://github.com/ColtHands/Vue-Click-Outside-Element/blob/master/src/index.ts

type ClickOutside = (event: MouseEvent) => void

interface ExtendedHTMLElement extends HTMLElement {
  clickOutside: ClickOutside
}

function clickOutside(this: ExtendedHTMLElement, bind: DirectiveBinding<Function>): ClickOutside {
  return event => {
      if(event.target instanceof Element) {
          if(!(this === event.target || this.contains(event.target))) {
              bind.value(event)
          }
      }
  }
}

const directive: ObjectDirective<ExtendedHTMLElement, Function> = {
  beforeMount(element, bind, vn): void {
      const isDirectiveValueFunction = bind?.value?.constructor.name === 'Function'

      if(!isDirectiveValueFunction) {
          throw Error('[v-click-outside-element] Function should be provided in the directive')
      }

      element.clickOutside = clickOutside.bind(element)(bind)

      window.addEventListener('click', element.clickOutside)
  },
  beforeUnmount(element): void {
      window.removeEventListener('click', element.clickOutside)
  },
  getSSRProps (binding, vnode) {
    return {}
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside-element', directive)
})
